import GENDERSALARYBYEXPERIENCE from 'data/mantechcar25/gender-salary-by-experience.json';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/router';
import React from 'react';
import {
  Bar,
  BarChart,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { StyledRecharts } from '../../shared/recharts/Recharts.styled';

const GenderSalaryByExperience: React.FC = () => {
  const { t } = useI18n('developer-career-report-2025');
  const { locale } = useRouter();

  return (
    <div>
      <StyledRecharts className="gender">
        <ResponsiveContainer height={300} width="99%" minWidth={700}>
          <BarChart data={GENDERSALARYBYEXPERIENCE} layout="vertical">
            <YAxis type="category" dataKey="exp" tickLine={false} />
            <XAxis
              type="number"
              allowDecimals={false}
              tickLine={false}
              padding={{ left: 20 }}
              tickFormatter={(tick) => {
                return `${tick / 1000}K`;
              }}
            />
            <Tooltip
              cursor={{ fill: '#d9ceff' }}
              labelStyle={{ display: 'none' }}
              separator=": "
              formatter={(value: number) => `${value.toLocaleString(locale)}€`}
              wrapperClassName="tooltip-x"
            />
            <Legend
              layout="horizontal"
              iconType="square"
              wrapperStyle={{ bottom: -5 }}
            />
            <Bar
              dataKey="female"
              name={t('mantechcar25.gender.females')}
              barSize={8}
              radius={5}
              fill="#974EA2"
            ></Bar>
            <Bar
              dataKey="male"
              name={t('mantechcar25.gender.males')}
              barSize={8}
              radius={5}
              fill="#7EAFD3"
            />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
    </div>
  );
};

export default GenderSalaryByExperience;
